/**
 * 服务端接口地址
 * - 开发/测试：通过 .env.development 注入 http://local-api.sanesee.com:8090
 * - 生产：通过 .env.production 注入 https://api.sanesee.com
 *
 * CRA 仅在编译时注入以 REACT_APP_ 开头的环境变量，所以打包后的产物里直接是字面量。
 */
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.sanesee.com';
